/** Published versions: list and roll back (activate). Route /sites/:id/versions */
import React, { useState } from 'react';
import { Button, Card, Popconfirm, Table, Tag, message } from 'antd';
import { RollbackOutlined } from '@ant-design/icons';
import { useTranslation } from '../../../shared/i18n';
import { fmtDate, listOf, toastErr, useLoad, useSite } from './common';

const Versions = () => {
    const { t } = useTranslation();
    const { api, reload: reloadSite } = useSite();
    const { data, loading, reload } = useLoad(() => api.get('/versions'), [api]);
    const [busy, setBusy] = useState(null);
    const activate = async (v) => {
        setBusy(v.version);
        try {
            await api.post(`/versions/${v.version}/activate`);
            message.success(t('Version {{v}} is live', { v: v.version }));
            reload();
            reloadSite();
        } catch (e) { toastErr(e); } finally { setBusy(null); }
    };
    return (
        <Card title={t('Versions')} size="small">
            <Table rowKey="version" size="small" loading={loading} dataSource={listOf(data)} pagination={{ pageSize: 20, hideOnSinglePage: true }}
                columns={[
                    { title: t('Version'), dataIndex: 'version', width: 100, render: (v, r) => <>v{v} {r.active && <Tag color="green">{t('Live', { context: 'shop' })}</Tag>}</> },
                    { title: t('Note', { context: 'shop' }), dataIndex: 'note', render: (v) => v || '-' },
                    { title: t('Published'), dataIndex: 'created_at', width: 180, render: (v) => fmtDate(v) },
                    {
                        title: '', key: 'a', width: 130, align: 'right', render: (_, r) => (r.active ? null : (
                            <Popconfirm title={t('Make version {{v}} live?', { v: r.version })} onConfirm={() => activate(r)}>
                                <Button size="small" icon={<RollbackOutlined />} loading={busy === r.version}>{t('Restore')}</Button>
                            </Popconfirm>
                        )),
                    },
                ]} />
        </Card>
    );
};

export default Versions;
